export { default } from './BatteryLow'
